export default __webpack_public_path__ + "static/media/000_wurz.2a7e241b.avif";